import { useNavigate } from "react-router-dom";
import { Facebook, Mail, Phone, MapPin } from "lucide-react";

const footerLinks = [
  { label: "Home", to: "/" },
  { label: "Gallery", to: "/gallery" },
  { label: "Reviews", to: "/reviews" },
  { label: "Contact", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy" },
];

const Footer = () => {
  const navigate = useNavigate();

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, to: string) => {
    e.preventDefault();
    navigate(to);
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, 100);
  };

  return (
    <footer className="bg-sage border-t mt-20">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-semibold mb-3">Soft Chaos Studio</h3>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Custom handmade gifts made with love. Bottle art, paintings and one-of-a-kind pieces designed around your story.
            </p>
            <div className="flex gap-3 mt-4">
              <a
                href="https://www.facebook.com/profile.php?id=61586838426531"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-card flex items-center justify-center text-muted-foreground hover:text-primary transition-colors shadow-soft"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif font-semibold mb-3">Contact</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-center gap-2">
                <Mail size={14} /> <a href="mailto:softchaos.uk@gmail.com" className="hover:text-primary transition-colors">softchaos.uk@gmail.com</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={14} /> <a href="tel:+447414896899" className="hover:text-primary transition-colors">+447414896899</a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={14} /> United Kingdom
              </li>
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-serif font-semibold mb-3">Quick Links</h4>
            <ul className="space-y-1 text-sm">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <a
                    href={link.to}
                    onClick={(e) => handleLinkClick(e, link.to)}
                    className="text-muted-foreground hover:text-primary transition-colors inline-block py-2 w-full touch-manipulation"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t mt-10 pt-6 text-center text-xs text-muted-foreground space-y-1">
          <p>© {new Date().getFullYear()} Soft Chaos Studio. All rights reserved.</p>
          <p>Built by <a href="https://webbsy.io" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">Webbsy.io</a> — all rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
